import {envService, useAccount, useModeration} from "@mytour/platform";
import * as Sentry from "@sentry/react";
import "app/App.scss";
import {useEffect} from "react";

export function SentryContainer() {
  const {account} = useAccount();
  const {isModeration} = useModeration();
  const email = account?.email;
  const id = account?.id;
  const login = account?.login;

  useEffect(() => {
    if (email || id || login || isModeration) {
      if (envService.getMode() === "prod" || envService.getMode() === "canary") {
        Sentry.setUser({id, login, email, isModeration});
      }
    } else {
      if (envService.getMode() === "prod" || envService.getMode() === "canary") {
        Sentry.setUser(null);
      }
    }
  }, [email, id, login, isModeration]);

  return null;
}
